import { useMutation } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { User } from "@customTypes/user";


interface MutationProps extends Partial<User> {
  password: string;
}

export const useCreateUser = () => {
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (formData: MutationProps) => {
      return api.post("user/create", {
        ...formData,
        full_name: formData.fullName,
      });
    },

    onError: (res: any) => {
      console.error("[From Create User]", res);

      handleErrors(res, "mutation");
    },
  });
};
